import React from 'react';
import { useMedia } from 'react-use';
import DetailImage from '@/components/ideas/DetailImage';
import { IIdea } from '@/@types/generated/contentful';

type ComponentProps = {
  idea: IIdea;
};

const DetailImageContainer: React.FC<ComponentProps> = ({ idea }) => {
  const isSp = useMedia('(max-width: 640px)');
  return <DetailImage idea={idea} isSp={isSp} />;
};

export default DetailImageContainer;
